module.exports = new __parcel__URL__("japanese.a7eed748.mp4").toString();